module.exports = __webpack_public_path__ + "static/media/huddle.a4b72054.jpg";